import { Flex, Text } from "@mantine/core";
import { useRouter } from "next/router";
import { memo } from "react";
import { useRecommendedText } from "src/component/element/ActivityView/hooks";
import { AvatarIconMemo } from "src/component/element/AvatarIcon";
import { useDateAndTimeTextFormatting } from "src/hooks";
import { useGetUserQuery } from "src/service/UsersApi";
import type { Activity } from "src/service/UsersApi/type";

import styles from "./ActivityView.module.scss";

const ActivityView = ({ category, createdAt, meta, userId }: Activity) => {
  const router = useRouter();
  const isMyPage = router.asPath.split("/")[1] === "mypage";
  const { data: user } = useGetUserQuery(userId);
  const date = useDateAndTimeTextFormatting(createdAt);
  const { text } = useRecommendedText({ category, meta });

  return (
    <Flex className={styles.activity}>
      <div className={styles.avatarIconWrap}>
        {user && (
          <AvatarIconMemo
            avatar={user?.profileImage}
            background={user?.profileBgImage}
          />
        )}
      </div>
      <div>
        <time className={styles.date} dateTime={date}>
          {date}
        </time>
        <Text size={14}>
          {isMyPage && (
            <>
              <span className={styles.username}>{user?.nickname}</span>
              <span>が</span>
            </>
          )}
          {text}
        </Text>
      </div>
    </Flex>
  );
};

export const ActivityViewMemo = memo(ActivityView);
